// File: hooks/useAudioMediaControls.js
import { useEffect } from 'react';

export function useAudioMediaControls(audioRef, { setPlaying, time, setTime, setDuration, initialTimeRestored }) {
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const handleTimeUpdate = () => {
      // Only update time after initial restoration is complete
      // This prevents overwriting the saved time with 0 before we restore it
      if (initialTimeRestored && !initialTimeRestored.current) {
        return;
      }
      const newTime = Number(audio.currentTime.toFixed(0));
      setTime(newTime);
    };
    const handleDurationChange = () => {
      setDuration(audio.duration);
    };
    const handlePause = () => {
      setPlaying(false);
    };
    const handlePlay = () => {
      setPlaying(true);
    };

    audio.addEventListener('timeupdate', handleTimeUpdate);
    audio.addEventListener('durationchange', handleDurationChange);
    audio.addEventListener('pause', handlePause);
    audio.addEventListener('play', handlePlay);

    if ('mediaSession' in navigator) {
      navigator.mediaSession.setActionHandler('play', () => {
        if (audio.paused) {
          audio.play();
        }
      });
      navigator.mediaSession.setActionHandler('pause', () => {
        if (!audio.paused) audio.pause();
      });
      navigator.mediaSession.setActionHandler('previoustrack', () => {
        audio.currentTime = Math.max(audio.currentTime - 10, 0);
      });
      navigator.mediaSession.setActionHandler('nexttrack', () => {
        audio.currentTime = Math.min(audio.currentTime + 30, audio.duration);
      });
    }

    return () => {
      audio.removeEventListener('timeupdate', handleTimeUpdate);
      audio.removeEventListener('durationchange', handleDurationChange);
      audio.removeEventListener('pause', handlePause);
      audio.removeEventListener('play', handlePlay);
    };
  }, [audioRef, setPlaying, setTime, setDuration]);
}
